/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobQueryCounters {
    getFixupPrototypeFunction() { return BackgroundJobQueryCounters.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobQueryCounters>): BackgroundJobQueryCounters {
        let obj = Object.assign(new BackgroundJobQueryCounters(), model);
        BackgroundJobQueryCounters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobQueryCounters>): BackgroundJobQueryCounters {
        if (!model) return null;
        return BackgroundJobQueryCounters.newInstance(<BackgroundJobQueryCounters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobQueryCounters) {
        if (!obj) return;

        models.BackgroundJobQueryCounters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobQueryCounters): boolean {
        Object.setPrototypeOf(obj, BackgroundJobQueryCounters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.entries) {
            for (let val of this.entries) {
                models.BackgroundJobQueryCounter.fixupPrototype(val);
            }
        }
    }

    /**
     * Frequency by action and filter
     */
    entries: Array<models.BackgroundJobQueryCounter>;

}
